import { connect } from 'react-redux';

import { Button } from '../../../components/Button';
import {
   addInstruments,
   setSendGain,
   setTrackOutRouting,
   setTrackRoutingItem,
   setView,
} from '../actions';
import { sequencerViewTypes } from '../constants';
import { FiToggleLeft, FiToggleRight } from 'react-icons/fi';
import { ControllerStyles } from '../../../components/ControllerStyles';
import { Knob } from '../../../components/Knob';

const mapStateToProps = ({ activeInterface: { instrumentRack, view } }) => {
   const activeInstrument = instrumentRack[view.instrumentIndex];
   const activeTrack = activeInstrument.mixerTrack;

   const availableTracks = [];

   instrumentRack.forEach((track, index) => {
      if (
         track.mixerTrack === activeTrack ||
         !track.auxTrack ||
         track.mixerTrack.sendTo?.[activeInstrument.id] != null
      ) {
         return;
      }

      const pushObject = {
         id: track.id,
         name: track.name,
         auxTrackIndex: index,
         isRouted: activeTrack.sendTo?.[track.id] != null,
         gain: activeTrack.sendTo?.[track.id],
      };

      availableTracks.push(pushObject);
   });

   return {
      availableTracks,
      sendOut: activeTrack.sendOut !== false, //must explicitly be false to not be sent out
      view,
   };
};

addInstruments;

const mapDispatchToProps = {
   setView,
   addInstruments,
   setSendGain,
   setTrackRoutingItem,
   setTrackOutRouting,
};

const TrackRouting = connect(
   mapStateToProps,
   mapDispatchToProps
)(
   ({
      view,
      availableTracks,
      sendOut,
      setView,
      addInstruments,
      setSendGain,
      setTrackRoutingItem,
      setTrackOutRouting,
   }) => {
      return (
         <div>
            <Button
               onClick={() =>
                  setView({
                     viewType: sequencerViewTypes.fullMixer,
                  })
               }
            >
               close
            </Button>
            <Button
               onClick={() =>
                  addInstruments([
                     {
                        name: 'Aux 1',
                        auxTrack: true,
                     },
                  ])
               }
            >
               add aux
            </Button>

            <div>
               <span>Main Output</span>

               <Button
                  onClick={() =>
                     setTrackOutRouting(view.instrumentIndex, !sendOut)
                  }
               >
                  {sendOut ? <FiToggleRight /> : <FiToggleLeft />}
               </Button>
            </div>
            {availableTracks.map(
               ({ id, name, isRouted, gain, auxTrackIndex }) => (
                  <div key={id}>
                     <span>{name}</span>
                     <Button
                        onClick={() =>
                           setTrackRoutingItem(
                              view.instrumentIndex, // fromTrackIndex
                              auxTrackIndex, // toTrackIndex
                              !isRouted // routingEnabled
                           )
                        }
                     >
                        {isRouted ? <FiToggleRight /> : <FiToggleLeft />}
                     </Button>

                     {isRouted && (
                        <svg height="32" width="32" style={{ margin: '2px' }}>
                           <ControllerStyles>
                              <Knob
                                 onChange={(value) =>
                                    setSendGain(
                                       view.instrumentIndex,
                                       auxTrackIndex,
                                       value
                                    )
                                 }
                                 value={gain}
                                 x={1}
                                 y={1}
                                 diameter={30}
                              />
                           </ControllerStyles>
                        </svg>
                     )}
                  </div>
               )
            )}
         </div>
      );
   }
);

export { TrackRouting };
